import { useMutation, useQueryClient } from "@tanstack/react-query";
import { fetchWithAuth } from "./fetcher.js";
import type { EmailDraftDecisionRequest, EmailDraftDecisionResponse } from "./types.js";

/**
 * Phase 17 D-DRAFT-03 — wait-for-server-then-refetch (mirrors Phase 15 D-DEC-FLOW-01).
 *
 * On 2xx -> invalidate ['email-draft', draftId] + ['email-drafts'] queries,
 * which triggers immediate refetch; the new notification_sent or
 * email_draft_rejected event lands in the timeline within one polling round-trip.
 *
 * Idempotency-key handled engine-side (Phase 13 D-DEC-01 mirror); SPA emits no
 * X-Idempotency-Key header.
 */
export function usePostEmailDraftDecision(draftId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (req: EmailDraftDecisionRequest) =>
      fetchWithAuth<EmailDraftDecisionResponse>(
        `/internal/v0/email-drafts/${draftId}/decisions`,
        { method: "POST", body: JSON.stringify(req) },
      ),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["email-draft", draftId] });
      qc.invalidateQueries({ queryKey: ["email-drafts"] });
    },
  });
}
